<template>
  <div :class="['nt-theme', getTheme]">
    <div v-if="isMobile">
      <nt-select2 
        ref="select" 
        :id="id" 
        :label="label" 
        :theme="theme"
        :placeholder="placeholder" 
        :validators="validators" 
        :data-source="dataSource"
        :value-selected="valueSelected"
      >
      </nt-select2>
    </div>
    <div v-if="!isMobile" :class="{ 'decorated' : decorated }">
      <label>{{ label }}</label>
      <div :id="id" class="nt-radiogroup" :class="{ 'nt-radiogroup--decorated' : decorated }">
        <nt-radio
          v-for="(item, i) in dataSource" :id="id + '-radio-' + i" :key="item.id"
          :item="item"
          :theme="theme"
          :value-selected="valueSelected"
          @onSelect="onSelect"
        >
        </nt-radio>
      </div>
      <div class="nt-form-error" v-if="error">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import NtRadio from './nt-form-radio.vue'
import NtSelect2 from '../nt-form-select-2/form-select-2.vue'

export default {
  name: 'nt-radiogroup',
  props: {
    id: {
      type: String,
      default: 'radiogroup'
    },
    theme: {
      type: String,
      default: 'default'
    },
    label: {
      type: String,
      default: null
    },
    valueSelected: {
      type: String,
      default: null
    },
    dataSource: {
      type: Array,
      default: []
    },
    placeholder: {
      type: String,
      default: null
    },
    validators: {
      type: Array,
      default: []
    },
    decorated: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: null,
      error: null,
      width: 0
    }
  },
  watch: {
    '$parent.errors': function (values) {
      this.error = _.values(_.find(values, this.id, _.first))[0]

      if (this.$refs.select) {
        this.$refs.select.error = this.error
      }
    }
  },
  created() {
    const { formData, validators } = this.$parent.$data

    // Add to form initial values
    Object.assign(formData, {
      [this.id]: this.selected
    })
    // Add validators to form
    Object.assign(validators, {
      [this.id]: this.validators
    })
    this.$on('changeForm', this.onSelect)
  },
  computed: {
    getTheme() {
      return `nt-theme--${this.theme}`
    },
    isMobile() {
      return this.width <= 766
    }
  },
  methods: {
    onSelect(item) {
      if (typeof item.Value === 'object') {
        this.selected = item.Value[this.id] !== this.selected ? item.Value[this.id] : null
      } else {
        this.selected = item.Value !== this.selected ? item.Value : null
      }

      this.changeForm()
      this.storeRealValue(item)

      if (this.$refs.select) {
        this.$refs.select.data.forEach(element => {
          if (element.Value === item.Value) {
            this.$refs.select.selected = element
          }
        })
      }
    },
    storeRealValue(item) {
      const { Text } = item
      this.$parent.$emit('storeRealValue', {
        [this.id]: Text
      })
    },
    changeForm() {
      this.$parent.$emit('changeForm', {
        [this.id]: this.selected
      })
    },
    onResize() {
      this.width = window.innerWidth
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  components: {
    NtRadio,
    NtSelect2
  }
}
</script>

<style lang="scss">
  .nt-theme {
    & .nt-radiogroup {
      $container: &;
      display: flex;
      flex-wrap: wrap;
      color: #3e3b37;

      .radio:not(:last-child) {
        margin-right: 20px;
      }

      &--decorated {
        justify-content: center;
        text-align: center;
        color: #9ddda9;
        font-weight: bold;

        & .radio {
          // border: 1px solid #9ddda9;
          // flex: 1;
          padding: 10px 30px 10px 30px;

          &:not(:last-child) {
            margin-right: 0;
          }
        }
      }
    }
    & .decorated {
      & label {
        font-weight: bold;
      }
      & label, .nt-form-error {
        text-align: center;
      }
    }
  }
</style>